<template>
  <section class="grid-container pt-8 pb-20 tablet:pt-16 tablet:pb-32">
    <div class="col-span-12 tablet:col-start-3 tablet:col-end-11">
      <RichText>
        <slot></slot>
      </RichText>
    </div>
  </section>
</template>

<script setup lang="ts">
import RichText from '@/components/JobBoard/RichText.vue'
</script>
